/**
 * Random bundle button.
 *
 * Configuration is injected as JSON in #rb-data by
 * snippets/random-forty-bundle.liquid. Notes on the design live there too — in
 * the snippet's Liquid comment, which is never sent to the browser.
 *
 * Anything written in THIS file is public, so keep comments neutral.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('rb-data');
  var button = document.getElementById('rb-fab');

  if (!dataEl || !button) {
    return;
  }

  var config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.warn('[rb] Could not parse the bundle configuration.', error);
    return;
  }

  // config.target and config.maxOvershoot are quoted in the store's BASE
  // currency, but the catalogue — and therefore the cart — prices in the
  // shopper's presentment currency. Shopify publishes the conversion rate for
  // the active currency, so both are scaled by it. Without this, a shopper
  // paying in a lower-value currency would receive a basket worth a fraction of
  // the intended amount.
  var BASE_CURRENCY = config.baseCurrency || 'USD';
  var shopCurrency = window.Shopify && window.Shopify.currency;
  var activeCurrency = (shopCurrency && shopCurrency.active) || BASE_CURRENCY;
  var rate = shopCurrency ? Number(shopCurrency.rate) : 0;
  var convertible = Boolean(rate) && rate > 0;

  // A non-base currency with no published rate cannot be converted, and guessing
  // would silently under-deliver. Offer no button rather than a wrong one.
  if (!convertible && activeCurrency !== BASE_CURRENCY) {
    button.remove();
    return;
  }

  if (!convertible) {
    rate = 1;
  }

  var target = Math.round((Number(config.target) || 3990) * rate);
  var maxItems = Number(config.maxItems) || 20;

  // The catalogue pool is fetched lazily and cached — see loadPool(). It starts
  // empty on purpose: nothing about the catalogue is embedded in the page.
  var pool = [];
  var poolPromise = null;

  // Let the basket finish just above the target rather than stopping short of it.
  var atLeast = config.atLeast !== false;

  // Hard cap on how far above the target the basket may finish. Quoted in the
  // base currency too, so it is scaled by the same rate.
  var maxOvershoot = Math.round(
    (config.maxOvershoot !== undefined && config.maxOvershoot !== null
      ? Number(config.maxOvershoot)
      : 400) * rate
  );
  var ceiling = target + maxOvershoot;

  // "For Resale / Small Biz" is not a product type: it means tagged Brand AND
  // (best-seller tag OR at least this price). Quoted in the base currency, so it
  // is scaled like every other money value here — the pool's prices are already
  // in the shopper's presentment currency.
  var resaleFloor = Math.round(
    (config.resaleFloor !== undefined && config.resaleFloor !== null
      ? Number(config.resaleFloor)
      : 500) * rate
  );

  // Bit layout, mirrored from sections/random-forty-pool.liquid. Bits 0-4 are
  // the shopper's themes; 32 and 64 are internal Brand / best-seller markers
  // that finish the Resale rule above.
  var THEME_MASK = 31;
  var RESALE_BIT = 16;
  var BRAND_BIT = 32;
  var BEST_BIT = 64;
  var COLOUR_MASK = 127;

  // Spam protection. cooldownMs throttles bursts and maxBundles budgets a
  // session. maxCartLines is an optional extra cap on the cart's line count,
  // OFF (0) by default: it only gates this button, and any fixed number would
  // eventually refuse a genuine bulk buyer.
  var cooldownMs = config.cooldownMs !== undefined ? Number(config.cooldownMs) : 1500;
  var maxBundles = config.maxBundles !== undefined ? Number(config.maxBundles) : 10;
  var maxCartLines =
    config.maxCartLines !== undefined ? Number(config.maxCartLines) : 0;

  var locked = false;
  var lastClickAt = 0;

  var labelEl = button.querySelector('.rb-fab__label');

  // The label states the target amount in the shopper's own currency. Liquid can
  // only render that when they already pay in the store's base currency, because
  // it has no conversion rate — so fill in the converted value here. This must
  // run BEFORE the resting label is captured, otherwise restoring it after a
  // click would put an unconverted amount back.
  var amountEl = button.querySelector('.rb-fab__amount');

  if (amountEl) {
    amountEl.textContent = formatMoney(target);
  }

  var restingLabel = labelEl ? labelEl.innerHTML : '';

  /* ---------------------------------------------------------------------- */
  /* Helpers                                                                */
  /* ---------------------------------------------------------------------- */

  function shuffle(list) {
    var out = list.slice();

    for (var i = out.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = out[i];
      out[i] = out[j];
      out[j] = swap;
    }

    return out;
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    var locale = config.locale;

    // Only hand Intl a plausible tag, otherwise let it use the browser default.
    if (!/^[a-z]{2}(-[a-zA-Z]{2,4})?$/.test(locale || '')) {
      locale = undefined;
    }

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: config.currency || 'USD'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function dispatch(name, detail) {
    // Provided globally by assets/app.js.
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent(name, detail);
    }
  }

  function cartRoute(name, fallback) {
    var routes = window.theme && window.theme.routes;
    return (routes && routes[name]) || fallback;
  }

  /* ---------------------------------------------------------------------- */
  /* Catalogue pool — lazy, whole-catalogue, cached                          */
  /* ---------------------------------------------------------------------- */

  /*
   * The catalogue is fetched on demand rather than embedded in the page, so
   * nothing is added to page weight and every visitor draws from the whole
   * catalogue. The result is cached, so only the first click pays for it.
   */

  // Keyed by currency. The cached prices are denominated in whatever currency the
  // shopper had when the pool was fetched, so switching currency must not reuse
  // them against a freshly converted target — that would size the basket from
  // stale prices and quietly deliver the wrong value.
  var POOL_CACHE_KEY = 'rb-pool-v4-' + activeCurrency;
  var SESSION_KEY = 'rb-bundles-used';
  var POOL_MAX_PAGES = 40;

  function poolRoot() {
    var routes = window.Shopify && window.Shopify.routes;
    return (routes && routes.root) || '/';
  }

  function fetchPoolPage(page) {
    var url =
      poolRoot() +
      '?section_id=' +
      encodeURIComponent(config.poolSection || 'random-forty-pool') +
      '&page=' +
      page;

    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(parsePoolPage)
      .catch(function () {
        return { page: 0, pages: 0, items: 0, data: '' };
      });
  }

  /** Splits one rendered pool page into its header fields and payload. */
  function parsePoolPage(html) {
    var marker = /RB\|(\d+)\|(\d+)\|(\d+)\|/.exec(html || '');

    if (!marker) {
      return { page: 0, pages: 0, items: 0, data: '' };
    }

    return {
      page: Number(marker[1]),
      pages: Number(marker[2]),
      items: Number(marker[3]),
      // Everything after the header is "id:price" pairs. Our own output holds
      // only digits, colons and commas, so the first "<" ends the payload —
      // which also crops the <div> wrapper Shopify adds around a section.
      data: html.slice(marker.index + marker[0].length).split('<')[0]
    };
  }

  /** Turns "id:price:theme:colour:group[:key]" into basket candidates. */
  function decodePool(compact) {
    var entries = compact.split(',');
    var out = [];

    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].split(':');

      if (parts.length < 5) {
        continue;
      }

      var id = Number(parts[0]);
      var price = Number(parts[1]);
      var tmask = Number(parts[2]) || 0;
      var cmask = Number(parts[3]) || 0;

      if (!(id > 0) || !(price > 0)) {
        continue;
      }

      var themes = tmask & THEME_MASK;

      // The Resale rule needs a price floor that Liquid cannot apply, because
      // it receives prices in the shopper's own currency. Finish it here so
      // every theme can then be treated the same way.
      if ((tmask & BRAND_BIT) && ((tmask & BEST_BIT) || price >= resaleFloor)) {
        themes |= RESALE_BIT;
      }

      out.push({
        i: id,
        p: price,
        t: themes,
        c: cmask & COLOUR_MASK,
        g: Number(parts[4]),
        // Present only on consumables; see the pool section.
        k: parts.length > 5 ? parts[5] : ''
      });
    }

    return out;
  }

  function readPoolCache() {
    try {
      var raw = window.localStorage.getItem(POOL_CACHE_KEY);

      if (!raw) {
        return null;
      }

      var cached = JSON.parse(raw);
      var ttl = (Number(config.cacheHours) || 6) * 3600 * 1000;

      if (!cached || !cached.data || !cached.time) {
        return null;
      }

      if (Date.now() - cached.time > ttl) {
        window.localStorage.removeItem(POOL_CACHE_KEY);
        return null;
      }

      return cached.data;
    } catch (error) {
      // Private browsing, storage disabled, quota — just skip the cache.
      return null;
    }
  }

  function writePoolCache(compact) {
    try {
      window.localStorage.setItem(
        POOL_CACHE_KEY,
        JSON.stringify({ time: Date.now(), data: compact })
      );
    } catch (error) {
      /* not fatal */
    }
  }

  /** Fetches an inclusive range of pool pages in parallel. */
  function fetchPoolPages(from, to) {
    var requests = [];

    for (var page = from; page <= to; page++) {
      requests.push(fetchPoolPage(page));
    }

    return Promise.all(requests);
  }

  /**
   * Resolves with the whole catalogue as [{ i: variantId, p: priceCents }].
   * Every page is requested at once; a short estimate is topped up afterwards.
   */
  function loadPool() {
    if (poolPromise) {
      return poolPromise;
    }

    var cached = readPoolCache();

    if (cached) {
      pool = decodePool(cached);
      poolPromise = Promise.resolve(pool);
      return poolPromise;
    }

    var estimated = Math.max(1, Math.min(Number(config.pages) || 1, POOL_MAX_PAGES));

    poolPromise = fetchPoolPages(1, estimated)
      .then(function (chunks) {
        var known = Math.min((chunks[0] && chunks[0].pages) || estimated, POOL_MAX_PAGES);

        if (known <= estimated) {
          return chunks;
        }

        return fetchPoolPages(estimated + 1, known).then(function (extra) {
          return chunks.concat(extra);
        });
      })
      .then(function (chunks) {
        var compact = chunks
          .map(function (chunk) {
            return chunk.data;
          })
          .filter(Boolean)
          .join(',');

        writePoolCache(compact);
        pool = decodePool(compact);

        if (!pool.length) {
          // Nothing usable — let a later click retry from scratch.
          poolPromise = null;
        }

        return pool;
      })
      .catch(function (error) {
        poolPromise = null;
        throw error;
      });

    return poolPromise;
  }

  /* ---------------------------------------------------------------------- */
  /* Honouring the shopper's two answers                                     */
  /* ---------------------------------------------------------------------- */

  /*
   * The pool carries a theme mask and a colour mask per product, so filtering
   * costs no extra request. In both masks 0 means "no preference expressed".
   */

  function bucket(themeBit, colourBit) {
    var out = [];

    for (var i = 0; i < pool.length; i++) {
      var item = pool[i];

      if (themeBit && !(item.t & themeBit)) {
        continue;
      }

      if (colourBit && !(item.c & colourBit)) {
        continue;
      }

      out.push(item);
    }

    return out;
  }

  /**
   * Is the target reachable from this pool? Takes the most expensive items
   * available, so it answers "is the value there at all" without pretending to
   * know which items the shuffle will pick. Anything already in the cart is
   * skipped, because a basket cannot reuse it.
   */
  function canReach(list, cart) {
    var prices = [];

    for (var i = 0; i < list.length; i++) {
      if (!cart.variants[list[i].i]) {
        prices.push(list[i].p);
      }
    }

    if (!prices.length) {
      return false;
    }

    prices.sort(function (a, b) {
      return b - a;
    });

    var sum = 0;
    var limit = Math.min(prices.length, maxItems);

    for (var j = 0; j < limit; j++) {
      sum += prices[j];
    }

    return sum >= target;
  }

  /**
   * Mirrors the pool's family-key normalisation: lower case, alphanumerics only.
   * Liquid can only strip the punctuation it knows about, so if the two ever
   * disagree the key simply fails to match — which is the safe direction, since
   * it keeps the consumable out of the basket.
   */
  function normaliseName(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  /**
   * A consumable (refill, lead, label roll) must never be bought on its own, so
   * it is allowed only when the product it belongs to is already in the cart.
   * That is a plain substring test against the normalised cart titles.
   */
  function consumableAllowed(item, cart) {
    if (!item.k) {
      return true;
    }

    for (var i = 0; i < cart.names.length; i++) {
      if (cart.names[i].indexOf(item.k) !== -1) {
        return true;
      }
    }

    return false;
  }

  function withoutUnmatchedConsumables(list, cart) {
    var out = [];

    for (var i = 0; i < list.length; i++) {
      if (consumableAllowed(list[i], cart)) {
        out.push(list[i]);
      }
    }

    return out;
  }

  /**
   * Widens the shopper's answers only as far as the catalogue forces, and
   * reports which promise had to be relaxed.
   *
   * Order: exact, then colour relaxed, then theme, then everything. Colour goes
   * first because a theme usually describes what the shopper is doing, while a
   * colour is easier to forgive. Returning no note means the answers were
   * honoured exactly.
   */
  function choosePool(themeBit, colourBit, cart) {
    var droppedAll = '';

    if (themeBit && colourBit) {
      droppedAll = config.noteBoth;
    } else if (colourBit) {
      droppedAll = config.noteColour;
    } else if (themeBit) {
      droppedAll = config.noteTheme;
    }

    var attempts = [{ theme: themeBit, colour: colourBit, note: '' }];

    if (colourBit) {
      attempts.push({ theme: themeBit, colour: 0, note: config.noteColour });
    }

    if (themeBit) {
      attempts.push({ theme: 0, colour: colourBit, note: droppedAll });
    }

    attempts.push({ theme: 0, colour: 0, note: droppedAll });

    var seen = {};

    for (var i = 0; i < attempts.length; i++) {
      var attempt = attempts[i];
      var key = attempt.theme + '/' + attempt.colour;

      if (seen[key]) {
        continue;
      }

      seen[key] = true;

      var list = withoutUnmatchedConsumables(bucket(attempt.theme, attempt.colour), cart);

      if (canReach(list, cart)) {
        return { pool: list, note: attempt.note || '' };
      }
    }

    // Even an unconstrained basket cannot reach the target (the shopper already
    // has most of the catalogue). The builder still gets as close as it can and
    // the note stays honest about what was lost.
    return {
      pool: withoutUnmatchedConsumables(pool, cart),
      note: droppedAll || ''
    };
  }

  /* ---------------------------------------------------------------------- */
  /* Basket builder                                                         */
  /* ---------------------------------------------------------------------- */

  /**
   * Picks a random basket that spreads across as many of the theme's product
   * families as the budget allows.
   *
   * Items are drawn one per family per pass, from shuffled families, so a theme
   * that stocks pens far more heavily than anything else still returns a mixed
   * basket. Drawing uniformly from the whole pool — the previous behaviour —
   * made the basket mirror the catalogue's bias: "Notetaking & Study + Black"
   * came back 77% pens with essentially no paper, because paper was 1.2% of
   * that pool while pens spanned nine separate product types.
   *
   * Phase 1 fills up to but not past the target; phase 2 crosses it with the
   * cheapest remaining item that stays inside the ceiling.
   */
  function buildBundle(candidateList) {
    var families = {};
    var order = [];
    var items = [];
    var total = 0;
    var cursors = {};
    var i;
    var candidate;

    for (i = 0; i < candidateList.length; i++) {
      candidate = candidateList[i];

      if (!candidate || candidate.p <= 0) {
        continue;
      }

      if (!families[candidate.g]) {
        families[candidate.g] = [];
        order.push(candidate.g);
      }

      families[candidate.g].push(candidate);
    }

    order = shuffle(order);

    // Shuffle inside each family too, so repeat clicks differ.
    for (i = 0; i < order.length; i++) {
      families[order[i]] = shuffle(families[order[i]]);
    }

    var progressed = true;

    // Phase 1 — one item per family per pass, until nothing else fits.
    while (progressed && items.length < maxItems) {
      progressed = false;

      for (i = 0; i < order.length && items.length < maxItems; i++) {
        var list = families[order[i]];
        var cursor = cursors[order[i]] || 0;

        while (cursor < list.length) {
          var picked = list[cursor];
          cursor++;

          if (total + picked.p <= target) {
            items.push(picked);
            total += picked.p;
            progressed = true;
            break;
          }
        }

        cursors[order[i]] = cursor;
      }
    }

    // Phase 2 - cross the target with the smallest possible overshoot.
    if (atLeast && total < target) {
      var best = null;

      for (i = 0; i < candidateList.length; i++) {
        candidate = candidateList[i];

        if (!candidate || candidate.p <= 0 || items.indexOf(candidate) !== -1) {
          continue;
        }

        if (
          total + candidate.p >= target &&
          total + candidate.p <= ceiling &&
          (best === null || candidate.p < best.p)
        ) {
          best = candidate;
        }
      }

      // If nothing can cross the target without breaching the ceiling, ship the
      // fill as-is rather than overcharging just to hit a number.
      if (best) {
        items.push(best);
        total += best.p;
      }
    }

    // Never hand back an empty basket.
    if (!items.length && candidateList.length) {
      var cheapest = candidateList.slice().sort(function (a, b) {
        return a.p - b.p;
      })[0];

      items.push(cheapest);
      total = cheapest.p;
    }

    return { items: items, total: total };
  }

  /* ---------------------------------------------------------------------- */
  /* Cart plumbing                                                          */
  /* ---------------------------------------------------------------------- */

  var SECTION_IDS = ['cart-drawer', 'cart-bubble'];

  function cartSections() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  /** POSTs basket items to the Cart AJAX API. Resolves { ok, payload }. */
  function postItems(items, withSections) {
    var body = {
      items: items.map(function (item) {
        return { id: item.i, quantity: 1 };
      })
    };

    if (withSections) {
      body.sections = SECTION_IDS;
      body.sections_url = window.location.pathname;
    }

    return fetch(cartRoute('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(
        function (payload) {
          return { ok: response.ok, payload: payload };
        },
        function () {
          return { ok: false, payload: null };
        }
      );
    });
  }

  /**
   * Fallback path: adds one item at a time, skipping whatever the API refuses,
   * and keeps drawing candidates until the target is reached. Used when the
   * batched add is rejected, so one bad line cannot sink the whole basket.
   */
  function addIndividually(planned, candidateList) {
    var added = [];
    var seen = {};
    var plannedIds = {};
    var total = 0;

    planned.forEach(function (item) {
      plannedIds[item.i] = true;
    });

    // Keep the randomised picks first so the basket still feels random, then top
    // up cheapest-first. That lands the total as close to the target as possible
    // instead of overshooting on one expensive item.
    var leftovers = candidateList
      .filter(function (item) {
        return !plannedIds[item.i];
      })
      .sort(function (a, b) {
        return a.p - b.p;
      });

    var queue = planned.concat(leftovers);

    function step(index) {
      if (index >= queue.length || total >= target || added.length >= maxItems) {
        return Promise.resolve(added);
      }

      var item = queue[index];

      if (!item || seen[item.i]) {
        return step(index + 1);
      }

      // Never let the basket grow past the ceiling.
      if (total + item.p > ceiling) {
        return step(index + 1);
      }

      seen[item.i] = true;

      return postItems([item]).then(function (result) {
        if (result.ok) {
          added.push(item);
          total += item.p;
        } else {
          console.warn('[rb] skipped');
        }

        return step(index + 1);
      });
    }

    return step(0);
  }

  /**
   * Adds the basket, preferring a single batched request. Resolves with the
   * items that actually landed in the cart plus any sections Shopify rendered.
   */
  function addItems(items, candidateList) {
    return postItems(items, true).then(function (result) {
      if (result.ok) {
        return { added: items, sections: (result.payload && result.payload.sections) || null };
      }

      console.warn('[rb] fallback');

      return addIndividually(items, candidateList).then(function (added) {
        return { added: added, sections: null };
      });
    });
  }

  /**
   * Reads the live cart. Returns the variants already in it (so a bundle can
   * skip them) plus the line count, which is the authoritative spam guard.
   */
  function readCart() {
    return fetch(cartRoute('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var variants = {};
        var names = [];

        (cart.items || []).forEach(function (item) {
          variants[item.variant_id] = true;
          // Kept for the consumable check: a refill may only be added when its
          // parent product is already in the cart.
          names.push(normaliseName(item.product_title));
          names.push(normaliseName(item.title));
        });

        return { variants: variants, count: cart.item_count || 0, names: names };
      })
      .catch(function (error) {
        console.warn('[rb] cart read failed', error);
        return { variants: {}, count: 0, names: [] };
      });
  }

  /** Asks Shopify to render the cart sections for the current cart. */
  function fetchSections() {
    var url = window.location.pathname + '?sections=' + SECTION_IDS.join(',');

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .catch(function (error) {
        console.warn('[rb] Could not refresh the cart sections.', error);
        return null;
      });
  }

  function innerHTMLFrom(sectionHTML, selector) {
    var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var match = doc.querySelector(selector);

    return match ? match.innerHTML : null;
  }

  /** Swaps the theme's cart markup for the freshly rendered sections. */
  function renderCartSections(sectionMap) {
    if (!sectionMap) {
      return;
    }

    cartSections().forEach(function (entry) {
      var host = document.getElementById(entry.id);
      var markup = sectionMap[entry.section];

      if (!host || !markup) {
        return;
      }

      var html = innerHTMLFrom(markup, entry.selector);

      if (html === null) {
        return;
      }

      (host.querySelector(entry.selector) || host).innerHTML = html;
    });

    // Re-bind the theme's own behaviours to the markup we just replaced.
    // These are top-level `class` declarations in assets/app.js, so they are
    // reachable as bare identifiers but NOT as properties of window.
    if (typeof CartDrawer !== 'undefined') {
      new CartDrawer();
    }

    if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
      new Cart();
    }
  }

  function openCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');

    if (!drawer) {
      return false;
    }

    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    dispatch('cart-drawer:open');

    return true;
  }

  /* ---------------------------------------------------------------------- */
  /* Feedback                                                               */
  /* ---------------------------------------------------------------------- */

  var toast;
  var toastTimer;

  function showToast(message) {
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'rb-toast';
      toast.className = 'rb-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      var text = document.createElement('span');
      text.className = 'rb-toast__message';

      var link = document.createElement('a');
      link.className = 'rb-toast__link';
      link.href = cartRoute('cart_url', '/cart');
      link.textContent = 'View cart';

      toast.appendChild(text);
      toast.appendChild(link);
      document.body.appendChild(toast);
    }

    toast.querySelector('.rb-toast__message').textContent = message;
    toast.classList.add('rb-toast--visible');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('rb-toast--visible');
    }, 6000);
  }

  /* ---------------------------------------------------------------------- */
  /* Spam protection                                                        */
  /* ---------------------------------------------------------------------- */

  function bundlesUsed() {
    try {
      return Number(window.sessionStorage.getItem(SESSION_KEY)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function countBundle() {
    var used = bundlesUsed() + 1;

    try {
      window.sessionStorage.setItem(SESSION_KEY, String(used));
    } catch (error) {
      /* not fatal */
    }

    return used;
  }

  function limitReached() {
    return maxBundles > 0 && bundlesUsed() >= maxBundles;
  }

  /**
   * Marks the button as used up. It stays clickable on purpose, so a further
   * click can explain why nothing happened rather than silently doing nothing.
   */
  function lockButton() {
    locked = true;
    button.classList.add('rb-fab--locked');
    button.setAttribute('aria-label', config.limitMessage || 'Limit reached');

    if (labelEl) {
      labelEl.textContent = config.limitLabel || 'Limit reached';
    }
  }

  function setBusy(isBusy, label) {
    button.disabled = isBusy;
    button.classList.toggle('rb-fab--busy', isBusy);
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');

    // Never clobber the locked label when a request finishes.
    if (!labelEl || locked) {
      return;
    }

    labelEl.innerHTML = isBusy ? (label || 'Adding') + '&hellip;' : restingLabel;
  }

  /* ---------------------------------------------------------------------- */
  /* Go                                                                     */
  /* ---------------------------------------------------------------------- */

  /**
   * Builds and adds one bundle from the shopper's two answers.
   *
   * The answers are honoured exactly whenever the catalogue can support it.
   * choosePool() widens the pool only when the exact combination cannot reach
   * the target, and reports what it relaxed so the confirmation can say so.
   */
  function runBundle(themeBit, colourBit) {
    if (button.disabled) {
      return;
    }

    // Guard 1 — throttle bursts of clicks.
    var now = Date.now();

    if (now - lastClickAt < cooldownMs) {
      return;
    }

    lastClickAt = now;

    // Guard 2 — this session's bundle budget.
    if (locked || limitReached()) {
      lockButton();
      showToast(config.limitMessage || 'Limit reached.');
      return;
    }

    setBusy(true, 'Loading');

    // Carried through to the confirmation so a relaxed basket can explain itself.
    var note = '';

    loadPool()
      .then(function (loaded) {
        if (!loaded.length) {
          throw new Error('Could not load the products. Please try again.');
        }

        setBusy(true, 'Adding');

        return readCart();
      })
      .then(function (cart) {
        // Guard 3 — the cart is authoritative, so this one cannot be bypassed
        // by clearing browser storage.
        if (maxCartLines > 0 && cart.count >= maxCartLines) {
          throw new Error('There are already a lot of items in your cart.');
        }

        // Widen the pool only as far as the catalogue forces, and remember why
        // so the shopper can be told.
        var choice = choosePool(themeBit, colourBit, cart);
        note = choice.note;

        // Prefer products the shopper does not already have.
        var fresh = choice.pool.filter(function (item) {
          return !cart.variants[item.i];
        });

        var freshValue = fresh.reduce(function (sum, item) {
          return sum + item.p;
        }, 0);

        var candidates = freshValue >= target ? fresh : choice.pool;

        return addItems(buildBundle(candidates).items, candidates);
      })
      .then(function (outcome) {
        var added = outcome.added;

        if (!added.length) {
          throw new Error('Nothing could be added to your cart just now. Please try again.');
        }

        // Report what actually made it in, which can be less than planned if
        // Shopify rejected individual lines.
        var total = added.reduce(function (sum, item) {
          return sum + item.p;
        }, 0);

        return (outcome.sections ? Promise.resolve(outcome.sections) : fetchSections()).then(
          function (sectionMap) {
            renderCartSections(sectionMap);
            dispatch('cart:item-added', { items: added });

            var count = added.length;
            var summary =
              'Added ' +
              count +
              (count === 1 ? ' item' : ' items') +
              ' \u00b7 ' +
              formatMoney(total);

            if (note) {
              summary += ' ' + note;
            }

            // Spend one bundle from this session's budget.
            countBundle();

            if (limitReached()) {
              lockButton();
            }

            // Confirmation. A relaxed basket always reports, even when a cart
            // drawer opens over it, because the shopper has to be told which of
            // their answers could not be honoured.
            if (note || !openCartDrawer()) {
              showToast(summary);
            }
          }
        );
      })
      .catch(function (error) {
        console.error('[rb]', error);
        showToast(error.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  // Reflect a budget that was already spent earlier in this session.
  if (limitReached()) {
    lockButton();
  }

  /* ---------------------------------------------------------------------- */
  /* The two questions                                                      */
  /* ---------------------------------------------------------------------- */

  /*
   * Answers are bitmasks read straight off the dialog markup, so the values in
   * snippets/random-forty-bundle.liquid and the bit order in
   * sections/random-forty-pool.liquid have to agree. 0 means "no preference".
   */
  var modal = document.getElementById('rb-modal');
  var noteEl = document.getElementById('rb-modal-note');
  var goButton = document.getElementById('rb-go');
  var goAmountEl = document.getElementById('rb-go-amount');

  if (goAmountEl) {
    goAmountEl.textContent = formatMoney(target);
  }

  /** Reads one option group out of the dialog markup. */
  function readOptions(attribute) {
    var nodes = modal ? modal.querySelectorAll('[' + attribute + ']') : [];
    var out = [];

    for (var i = 0; i < nodes.length; i++) {
      out.push({
        el: nodes[i],
        value: Number(nodes[i].getAttribute(attribute)) || 0
      });
    }

    return out;
  }

  var themeOptions = readOptions('data-rb-theme');
  var colourOptions = readOptions('data-rb-colour');
  var themeChoice = 0;
  var colourChoice = 0;
  var preparedCart = null;
  var lastFocused = null;

  function wireGroup(group, setChoice) {
    group.forEach(function (entry) {
      entry.el.addEventListener('click', function () {
        group.forEach(function (other) {
          other.el.setAttribute('aria-pressed', other === entry ? 'true' : 'false');
        });

        setChoice(entry.value);
        refreshNote();
      });
    });
  }

  /** Preselects the wildcard so Go is always a valid choice. */
  function selectWildcard(group, setChoice) {
    for (var i = 0; i < group.length; i++) {
      if (group[i].value === 0) {
        group[i].el.setAttribute('aria-pressed', 'true');
        setChoice(0);
        return;
      }
    }
  }

  /**
   * Warns BEFORE the shopper commits when their exact answers cannot be filled,
   * so a relaxed basket is never a surprise. Silent while the pool is still
   * loading, and silent when the answers can be honoured in full.
   */
  function refreshNote() {
    if (!noteEl || !preparedCart) {
      return;
    }

    var choice = choosePool(themeChoice, colourChoice, preparedCart);

    if (choice.note) {
      noteEl.textContent = choice.note;
      noteEl.hidden = false;
    } else {
      noteEl.hidden = true;
    }
  }

  /**
   * Warms the pool and the cart while the dialog is open, so Go feels instant
   * and the note can be worked out. A failure here is not fatal — Go retries.
   */
  function prepare() {
    return Promise.all([loadPool(), readCart()])
      .then(function (results) {
        preparedCart = results[1];
        refreshNote();
      })
      .catch(function () {
        preparedCart = null;
      });
  }

  function openModal() {
    if (!modal) {
      // No dialog in the markup: fall back to an unconstrained basket.
      runBundle(0, 0);
      return;
    }

    if (!modal.hidden) {
      return;
    }

    lastFocused = document.activeElement;
    noteEl.hidden = true;
    modal.hidden = false;
    document.body.classList.add('rb-modal-open');

    // Paint the hidden state first, or the transition has nothing to run from.
    window.requestAnimationFrame(function () {
      modal.classList.add('rb-modal--visible');
    });

    if (themeOptions.length) {
      themeOptions[0].el.focus();
    }

    prepare();
  }

  function closeModal() {
    if (!modal || modal.hidden) {
      return;
    }

    modal.classList.remove('rb-modal--visible');
    document.body.classList.remove('rb-modal-open');

    window.setTimeout(function () {
      modal.hidden = true;
    }, 220);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  /** Keeps Tab inside the dialog while it is open. */
  function trapFocus(event) {
    if (event.key !== 'Tab' || !modal || modal.hidden) {
      return;
    }

    var focusable = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (!focusable.length) {
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  if (modal) {
    wireGroup(themeOptions, function (value) {
      themeChoice = value;
    });

    wireGroup(colourOptions, function (value) {
      colourChoice = value;
    });

    selectWildcard(themeOptions, function (value) {
      themeChoice = value;
    });

    selectWildcard(colourOptions, function (value) {
      colourChoice = value;
    });

    var dismissers = modal.querySelectorAll('[data-rb-dismiss]');

    for (var d = 0; d < dismissers.length; d++) {
      dismissers[d].addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      trapFocus(event);
    });

    if (goButton) {
      goButton.addEventListener('click', function () {
        closeModal();
        runBundle(themeChoice, colourChoice);
      });
    }
  }

  button.addEventListener('click', function () {
    if (button.disabled) {
      return;
    }

    // A spent budget explains itself rather than opening the chooser, and the
    // cooldown still applies so the message cannot be spammed.
    if (locked || limitReached()) {
      var now = Date.now();

      if (now - lastClickAt >= cooldownMs) {
        lastClickAt = now;
        lockButton();
        showToast(config.limitMessage || 'Limit reached.');
      }

      return;
    }

    openModal();
  });

  /* ---------------------------------------------------------------------- */
  /* Optional warm-up                                                       */
  /* ---------------------------------------------------------------------- */

  // Off by default: fetching the catalogue up front costs every visitor ~55 KB,
  // including those who never click the button. Switch it on if an instant first
  // click matters more than that.
  if (config.prefetch) {
    var warmPool = function () {
      loadPool().catch(function () {
        // Swallow it — a click will retry from scratch.
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmPool, { timeout: 4000 });
    } else {
      window.setTimeout(warmPool, 1500);
    }
  }
})();
